export enum ColumnType {
  CommentCount = 'commentCount',
  ParentFolderName = 'parentFolderName',
  Parent = 'Parent',
  Description = 'description',
  DragHandle = 'drag-handle',
  Dimensions = 'dimensions',
  Searchable = 'searchable',
  Thumbnail = 'thumbnail',
  ExpiresAt = 'expiresAt',
  Automatic = 'automatic',
  CreatedBy = 'createdBy',
  ParentTag = 'parentTag',
  Watermark = 'watermark',
  FileType = 'fileType',
  Statuses = 'statuses',
  Checksum = 'checksum',
  FileName = 'fileName',
  Progress = 'progress',
  Profile = 'profile',
  Invitee = 'invitee',
  UserId = 'user_id',
  Select = 'select',
  Status = 'status',
  Rating = 'rating',
  Format = 'format',
  NodeId = 'nodeId',
  Public = 'public',
  Facet = 'facet',
  Roles = 'roles',
  Count = 'count',
  Group = 'group',
  Role = 'role',
  Name = 'name',
  Text = 'text',
  Size = 'size',
  Path = 'path',
  Type = 'type',
  User = 'user',
  Slug = 'slug',
  Id = 'id',
}

/**
 * Declarative column spec consumed by `buildColumns` / the layouts. `type`
 * selects the factory in `ColumnComponents`; `opts` are forwarded to it.
 */
export interface ColumnConfig<_T> {
  type: ColumnType;
  opts?: any;
  hide?: boolean;
}
